<template>
  <div ref="allList" class="sort_fa">
    <a-affix :offset-top="0">
      <div class="header_div">
        <div class="content_head flex_row_bt">
          <div class="exam_name" :title="seName + $t('exam.seNameTit')">
            {{ seName + $t('exam.seNameTit') }}
          </div>
          <div class="flex_row_end">
            <div v-if="campusList.length" class="ml-16">
              <span class="mr-12 ft-14 label"> {{ $t('exam.label1') }}: </span>
              <a-select
                v-model="campusId"
                style="width: 160px"
                :get-popup-container="
                  triggerNode => {
                    return triggerNode.parentNode
                  }
                "
                @change="changecampus"
              >
                <a-select-option
                  v-for="item in campusList"
                  :key="item.id"
                  :value="item.id"
                >
                  {{ item.campusName }}
                </a-select-option>
              </a-select>
            </div>
            <div v-if="dId" class="ml-16">
              <span class="mr-12 ft-14 label"> {{ $t('exam.label2') }}: </span>
              <a-select
                v-model="dId"
                style="width: 160px"
                :get-popup-container="
                  triggerNode => {
                    return triggerNode.parentNode
                  }
                "
                @change="changeZubie"
              >
                <a-select-option
                  v-for="item in zubieList"
                  :key="item.id"
                  :value="item.id"
                >
                  {{ item.name }}
                </a-select-option>
              </a-select>
            </div>
            <div class="ml-16">
              <span class="mr-12 ft-14 label"> {{ $t('exam.label3') }}: </span>
              <a-select
                v-model="classId"
                style="width: 160px"
                :get-popup-container="
                  triggerNode => {
                    return triggerNode.parentNode
                  }
                "
                @change="changeClass"
              >
                <a-select-option
                  v-for="item in classList"
                  :key="item.classId"
                  :value="item.classId"
                >
                  {{ item.className }}
                </a-select-option>
              </a-select>
            </div>
          </div>
        </div>
      </div>
    </a-affix>
    <div class="sort">
      <a-alert
        v-if="!noViewAll"
        class="alert"
        type="info"
        show-icon
        closable
        :message="$t('exam.alertText')"
      />
      <div class="content_top">
        <a-row :gutter="20">
          <a-col :span="8" class="public_top">
            <div class="bgc top_item top_item0">
              {{ $t('exam.toptext1') }}
              <span>{{ infoData.fullScore || '--' }}</span>
              {{ $t('exam.toptext1') }}
            </div>
          </a-col>
          <a-col :span="8" class="public_top">
            <div class="bgc top_item top_item1">
              {{ $t('exam.toptext2') }}
              <span>
                {{
                  typeof infoData.difficulty === 'number'
                    ? infoData.difficulty
                    : '--'
                }}
              </span>
            </div>
          </a-col>
          <a-col :span="8" class="public_top">
            <div class="bgc top_item top_item2">
              {{ $t('exam.toptext3') }}
              <span>
                {{
                  typeof infoData.discrimination === 'number'
                    ? infoData.discrimination
                    : '--'
                }}
              </span>
            </div>
          </a-col>
        </a-row>
        <a-row :gutter="10" type="flex" class="mt12">
          <a-col flex="50px">
            <div class="bgc grade_title">
              <span>{{ $t('exam.gradeTit[0]') }}</span>
              <span>{{ $t('exam.gradeTit[1]') }}</span>
              <span>{{ $t('exam.gradeTit[2]') }}</span>
              <span>{{ $t('exam.gradeTit[3]') }}</span>
            </div>
          </a-col>
          <a-col flex="auto">
            <a-row :gutter="12">
              <a-col
                v-for="(item, index) in topList"
                :key="index"
                :span="4"
                class="grade_div"
              >
                <div class="bgc grade_view flex_row_bt">
                  <div>
                    <span class="font-bold">
                      {{ Number(item.val) >= 0 ? item.val : '--' }}
                      <span v-if="index == 4">%</span>
                    </span>
                    <span v-if="index == 0">
                      {{ $t('exam.ren') }}
                    </span>
                    <span v-if="index > 0 && index < 4">
                      {{ $t('exam.fen') }}
                    </span>
                    <p>{{ item.title }}</p>
                  </div>
                  <img :src="item.img" alt="" />
                </div>
              </a-col>
            </a-row>
          </a-col>
        </a-row>
        <a-row v-if="classId" :gutter="10" type="flex" class="mt12">
          <a-col flex="50px">
            <div class="bgc grade_title flex_row_bt">
              <span>{{ $t('exam.classTit[0]') }}</span>
              <span>{{ $t('exam.classTit[1]') }}</span>
              <span>{{ $t('exam.classTit[2]') }}</span>
              <span>{{ $t('exam.classTit[3]') }}</span>
            </div>
          </a-col>
          <a-col flex="auto">
            <a-row :gutter="12">
              <a-col
                v-for="(item, index) in classtopList"
                :key="index"
                :span="4"
                class="grade_div"
              >
                <div class="bgc grade_view flex_row_bt">
                  <div>
                    <span class="font-bold">
                      {{ Number(item.val) >= 0 ? item.val : '--' }}
                    </span>
                    <span v-if="index == 0">
                      {{ $t('exam.ren') }}
                    </span>
                    <span v-if="index > 0 && index < 4">
                      {{ $t('exam.fen') }}
                    </span>
                    <span v-if="index == 4">%</span>
                    <p>{{ item.title }}</p>
                  </div>
                  <img :src="item.img" alt="" />
                </div>
              </a-col>
            </a-row>
          </a-col>
        </a-row>
      </div>
      <NotData v-if="sendStatus && !sortList.length">
        <template #msg> {{ $t('exam.notTabel') }} </template>
      </NotData>
      <div>
        <div
          v-for="(item, index) in sortList"
          :id="item.id"
          :key="item.ReportName"
          :class="['sort_div mt-32', 'index_' + index]"
        >
          <div :class="['sort_son', item.location]">
            <component
              :is="item.compents"
              :id="item.typeId || ''"
              :key="$route.fullPath"
              :cache="item.cache"
              :show="item.show || true"
              :item-title="item.ReportName || ''"
              :type="item.type || ''"
              :is-set="isSet"
              :hide-rank="hideRank"
            />
          </div>
        </div>
        <a-anchor
          :class="[
            'right_ul',
            {
              fixcenter: sortList.length > 10
            }
          ]"
          :show-ink-in-fixed="false"
          @click="handleClick"
        >
          <a-anchor-link
            v-for="(item, index) in sortList"
            :key="index"
            :href="'#' + item.id"
            :title="item.ReportName"
          />
        </a-anchor>
      </div>
    </div>
  </div>
</template>
<script>
  import axios, { setCookie } from '@utils'
  import Loading from '@comp/loading'

  // 全科

  import overview1 from '@view/dateCenter/details/overview1'
  import studentscore from '@view/dateCenter/details/total/studentscore'
  import quartile from '@view/dateCenter/details/total/quartile'
  //以下新加的
  import scoreseg from '@view/dateCenter/details/scoreSeg.vue'
  import fourRate from '@view/dateCenter/details/fourRate.vue'
  // import critiCal from '@view/dateCenter/details/critiCal.vue'
  import scoreLineContrast from '@view/dateCenter/details/scoreLineContrast.vue'
  import avgscoreContrast from '@view/dateCenter/details/avgscoreContrast.vue'

  import img1 from './img/grade1.png'
  import img2 from './img/grade2.png'
  import img3 from './img/grade3.png'
  import img4 from './img/grade4.png'
  import img5 from './img/grade5.png'
  import img6 from './img/grade6.png'

  export default {
    components: {
      overview1,
      studentscore,
      quartile,
      Loading,
      scoreseg,
      fourRate,
      scoreLineContrast,
      avgscoreContrast
      // critiCal
    },
    data() {
      return {
        campusId: '',
        campusList: [],
        dataEle: null,
        href: `${process.env.VUE_APP_Base}/app/base/homePage`,
        loading: false,
        classId: null,
        classList: [], //班级
        visible: true,
        sortList: [],
        totalNav: [],
        sortListTotal: [
          //右侧导航栏配置和各个模块标题配置
          {
            ReportName: this.$t('exam.sortListTotal[1]'),
            id: 1,
            compents: 'studentscore',
            overviewId: 'studentReport',
            location: 'A1'
          },
          {
            ReportName: this.$t('exam.sortListTotal[2]'),
            id: 2,
            typeId: 'chartF',
            compents: 'quartile',
            overviewId: 'quartile'
          },
          {
            ReportName: this.$t('exam.sortListTotal[3]'),
            id: 3,
            compents: 'overview1',
            overviewId: 'personalizedAvgScoreSet',
            type: 'score'
          },
          {
            ReportName: this.$t('exam.sortListTotal[5]'),
            id: 5,
            typeId: 'chartJ',
            compents: 'fourRate',
            overviewId: 'fourRateSet'
          },
          {
            ReportName: this.$t('exam.sortListTotal[6]'),
            id: 6,
            typeId: 'chartC',
            compents: 'fourRate',
            overviewId: 'fractionalLineSet'
          },
          {
            ReportName: this.$t('exam.sortListTotal[7]'),
            id: 7,
            typeId: 'chartH',
            compents: 'scoreseg',
            overviewId: 'fractionalSegSet'
          },
          {
            ReportName: this.$t('exam.sortListTotal[8]'),
            id: 8,
            typeId: 'chartI',
            compents: 'scoreseg',
            overviewId: 'rankSegSet'
          }

          // {
          //   title: '临界生分析',
          //   id: 9,
          //   children: [
          //     {
          //       title: '临界生分析',
          //       typeId: 'chartD',
          //       compents: 'critiCal'
          //     }
          //   ]
          // }
        ],
        contrastNav: [
          {
            ReportName: this.$t('exam.contrastNav[0]'),
            id: 21,
            typeId: 'studentcontrast',
            compents: 'studentscore',
            overviewId: 'studentReport',
            hideRank: true
          },
          {
            ReportName: this.$t('exam.contrastNav[1]'),
            id: 19,
            compents: 'avgscoreContrast',
            overviewId: 'personalizedAvgScoreSet'
          },
          {
            ReportName: this.$t('exam.contrastNav[2]'),
            id: 20,
            typeId: 'scoreLineContrast',
            compents: 'scoreLineContrast',
            overviewId: 'fractionalLineSet'
          }
        ],
        authId: 0,
        course: {}, // 科目
        singleExams: [], // 科目list
        seId: null, //单科id
        meId: null, //考试id
        seName: null, //考试名称
        barRadius: [6, 6, 0, 0],
        splitNum: 7,
        noViewAll: 1, //0未批阅完
        onceLoad: true, //第一次进页面

        //新增的字段
        dId: null,
        zubieList: [], //组别
        avgscoreList: [], //均分
        topList: [
          //年级概览
          {
            title: this.$t('exam.topList[0]'),
            dataIndex: 'studentCount',
            img: img1
          },
          {
            title: this.$t('exam.topList[1]'),
            dataIndex: 'maxScore',
            img: img2
          },
          {
            title: this.$t('exam.topList[2]'),
            dataIndex: 'minScore',
            img: img3
          },
          {
            title: this.$t('exam.topList[3]'),
            dataIndex: 'avgScore',
            img: img4
          },
          {
            title: this.$t('exam.topList[4]'),
            dataIndex: 'upAvgScoreBili',
            img: img5
          },
          {
            title: this.$t('exam.topList[5]'),
            dataIndex: 'meStandardDeviation',
            img: img6
          }
        ],
        classtopList: [
          //班级概览
          {
            title: this.$t('exam.classtopList[0]'),
            dataIndex: 'studentCount',
            img: img1
          },
          {
            title: this.$t('exam.classtopList[1]'),
            dataIndex: 'maxScore',
            img: img2
          },
          {
            title: this.$t('exam.classtopList[2]'),
            dataIndex: 'minScore',
            img: img3
          },
          {
            title: this.$t('exam.classtopList[3]'),
            dataIndex: 'avgScore',
            img: img4
          },
          {
            title: this.$t('exam.classtopList[4]'),
            dataIndex: 'upAvgScoreBili',
            img: img5
          },
          {
            title: this.$t('exam.classtopList[5]'),
            dataIndex: 'meStandardDeviation',
            img: img6
          }
        ],
        infoData: {}, //概览数据
        sendStatus: false,
        isSet: true,
        hideRank: false //是否隐藏班排年排
      }
    },
    watch: {
      $route: {
        handler(newData, oldData) {
          var noChangeId = []
          var groupStatus = newData.query.dId === oldData.query.dId
          var subjectStatus =
            newData.query.subjectId === oldData.query.subjectId
          if (
            groupStatus &&
            subjectStatus &&
            newData.query.classId !== oldData.query.classId
          ) {
            noChangeId = [
              // 'quartile',
              // 'personalizedAvgScoreSet',
              'fourRateSet',
              'fractionalLineSet',
              // 'fractionalSegSet',
              // 'rankSegSet',
              'scoreLineContrast'
            ]
          }

          this.sortList = this.sortList.map(item => {
            const status = noChangeId.some(itemc => itemc === item.overviewId)
            item.cache = true
            if (!status) item.cache = false
            return item
          })
          this.getViewStatus()
          // 加载概览
          this.dataLoad()
        }
      }
    },
    created() {
      let { meId, seId, seName, dId, classId } = this.$route.query
      this.seName = seName
      this.seId = seId * 1
      this.meId = meId
      this.dId = dId * 1
      this.classId = classId * 1
      this.getReport()
      // if (!+examIsActive) {
      //   //获取用户信息
      //   getUser({ latest: true }).then(({ data }) => {
      //     // 隐藏排名列 (不是管理员，并且showRank = 0)

      //     this.hideRank = !data.roleStr.includes('A') && !data.showRank
      //     if (this.hideRank) {
      //       this.contrastNav = this.contrastNav.filter(item => !item.hideRank)
      //     }
      //     //获取页面菜单
      //     this.getIsset(dId).then(data => {
      //       this.isSet = data
      //       if (data) {
      //         this.totalNav = [...this.sortListTotal, ...this.contrastNav]
      //       } else {
      //         this.totalNav = [...this.sortListTotal]
      //       }
      //       this.getReport()
      //     })
      //   })
      // } else {
      //   this.totalNav = [...this.sortListTotal]
      //   this.getReport()
      // }
    },
    mounted() {
      let { token } = this.$route.query
      if (token) {
        setCookie('X-ZYLX-TOKEN', token)
      }
      this.dataEle = this.$refs.allList
      this.getCampusList()
      // if (this.dId) {
      //   //获取组别
      //   this.getZubie()
      // } else {
      //   this.loadMain()
      // }
      // this.getViewStatus()
      // // 加载概览
      // this.dataLoad()
      // 监测是否有更换网页icon
      this.checkIcon()
    },
    methods: {
      getCampusList() {
        let { meId, seId, dId } = this.$route.query
        axios({
          url: 'getschoolcampuslist',
          params: {
            meId,
            seId,
            dId
          },
          loading: false
        }).then(res => {
          this.campusList = res.data || []
          this.campusId = this.campusList[0] ? this.campusList[0].id : ''
          this.changecampus()
        })
      },
      changecampus() {
        if (this.dId) {
          //获取组别
          this.getZubie().then(() => {
            this.getViewStatus()
            // 加载概览
            this.dataLoad()
          })
        } else {
          this.loadMain().then(() => {
            this.getViewStatus()
            // 加载概览
            this.dataLoad()
          })
        }
      },
      changeZubie(e) {
        this.dId = e
        const zbAvtive = this.zubieList.filter(item => item.id == this.dId)
        //班级
        this.classList = zbAvtive.length
          ? zbAvtive[0].classData
          : this.zubieList[0].classData
        let list = []
        this.getIsset(this.dId).then(data => {
          this.isSet = data
          if (data) {
            list = [...this.contrastNav]
          }
          this.totalNav = [...this.sortListTotal, ...list]
          this.getReport()
        })
        this.getSelect()
      },
      getZubie() {
        this.dId = this.$route.query.dId * 1
        let url = +this.$route.query.examIsActive
          ? 'getdistinctiveclassSchoolUnion'
          : 'getdistinctiveclasssubject'
        return axios({
          url,
          params: {
            meId: this.meId,
            campusId: this.campusId
          },
          loading: false
        }).then(res => {
          this.zubieList = res.data || []
          const index = this.zubieList.findIndex(item => item.id == this.dId)
          if (this.zubieList.length && index == -1) {
            this.dId = this.zubieList[0].id
          }
          const zbAvtive = this.zubieList.filter(item => item.id == this.dId)
          //班级
          this.classList = zbAvtive.length ? zbAvtive[0].classData : []

          this.getSelect()
        })
      },
      getSelect() {
        let subfilter = this.classList.filter(
          item => item.classId == this.classId
        )
        if (!subfilter.length)
          this.classId = this.classList.length
            ? this.classList[0].classId
            : this.classId
        this.changeQuery()
      },
      // 考试是否批阅完成
      getViewStatus() {
        let { meId, examIsActive = 1, campusId } = this.$route.query
        let url = +examIsActive
          ? 'getsingleexammarkingstatusunion'
          : 'getsingleexammarkingstatus'

        axios({
          host: 'testApi',
          url,
          params: {
            meId,
            campusId
          }
        }).then(res => {
          this.noViewAll = res.data === 0 ? res.data : 1
          // let { location } = this.$route.query
          // if (this.onceLoad && !location) {
          //   setTimeout(() => {
          //     let ele = document.querySelectorAll(
          //       '.right_ul .ant-anchor .ant-anchor-link img'
          //     )
          //     if (ele && ele[0]) {
          //       ele[0].click()
          //     }
          //   }, 200)
          //   this.onceLoad = false
          // }
        })
      },
      checkIcon() {
        let query = this.$route.query
        if (query.schoolIcon) {
          this.changeFavicon(query.schoolIcon)
        }
      },
      // 更换网页icon
      changeFavicon(link) {
        let favicon = document.querySelector('link[rel="icon"]')
        if (favicon !== null) {
          favicon.href = link
        } else {
          favicon = document.createElement('link')
          favicon.rel = 'icon'
          favicon.href = link
          document.head.appendChild(favicon)
        }
      },
      // 锚点
      handleClick(e) {
        e.preventDefault()
      },
      clickImg(e) {
        Element.prototype.trigger = event => {
          this.dispatchEvent(new Event(event))
        }
        e.srcElement.parentNode.firstChild.trigger('click')
      },
      // 获取班级下拉框
      loadMain() {
        let url = +this.$route.query.examIsActive
          ? 'getclasssubjectSchoolUnion'
          : 'datacentergetclasslist'
        const params = {
          meId: this.meId,
          seId: this.seId,
          campusId: this.campusId
        }
        return axios({
          url,
          params
        }).then(res => {
          if (res.status) {
            this.classList = res.data
            this.getSelect()
          } else {
            this.classId = ''
            this.changeQuery()
          }
        })
      },
      //获取是否设置数据对比
      getIsset(dId) {
        let { meId, campusId, examIsActive } = this.$route.query

        let params = {
          meId,
          dId,
          campusId
        }
        if (+examIsActive) {
          params.isUnion = 1
        }
        return axios({
          url: 'examcomparisonset',
          params,
          loading: false
        }).then(res => {
          return res.data
        })
      },
      // 获取报表权限
      getReport() {
        let { meId, examIsActive, campusId, dId } = this.$route.query
        axios({
          url: 'getnewreportcheck',
          params: {
            meId,
            type: +examIsActive ? 2 : 1, //1校考 2联考
            groupId: +examIsActive ? 7 : 5, //7局端全科 5校端全科
            campusId
          },
          loading: false
        })
          .then(res => {
            if (res.status && res.data) {
              let data = res.data || []

              let all = {}

              this.sortListTotal.forEach(i => {
                all[i.overviewId] = i
              })

              let list = data.map(i => {
                let active = all[i.ReportCode] || {}
                return { ...active, ...i }
              })

              list = list.filter(item => item.IsEnabled)
              //获取 是否设置 数据对比
              this.getIsset(dId).then(data => {
                this.isSet = data
                // 联考和校考  只在校考的地方添加
                let addlist = +examIsActive
                  ? [this.contrastNav[0]]
                  : this.contrastNav
                this.sortList = data ? [...list, ...addlist] : list
              })
            }
          })
          .finally(() => {
            this.sendStatus = true
          })
      },
      changeClass(e) {
        this.classId = e
        this.changeQuery()
      },
      changeQuery(params) {
        let query = {
          ...this.$route.query,
          ...params,
          classId: this.classId,
          dId: this.dId,
          campusId: this.campusId
        }
        let n = this.$route.query.seName
        if (n) {
          query.seName = n
        }
        this.$router.push({
          query
        })
      },
      //概览数据
      dataLoad() {
        let {
          seId,
          meId,
          classId,
          dId,
          examIsActive = 1,
          schoolId,
          campusId
        } = this.$route.query
        let url = +examIsActive ? 'getexammaininfoUnion' : 'mainInfoListUrl'
        let obj = +examIsActive ? { schoolId: +schoolId } : {}
        let data = {
          id: +seId,
          type: 1,
          classId: +classId,
          meId: +meId,
          groupId: +dId || 0,
          campusId,
          ...obj
        }
        axios({
          url,
          type: 'post',
          data,
          loading: false
        }).then(res => {
          let info = [
            'gradeExamMainInfo',
            'unionExamMainInfo',
            'schoolExamMainInfo'
          ]
          this.infoData = res.data[info[examIsActive]] || {}
          let lastData = this.topList.map(item => {
            item.val = this.infoData[item.dataIndex]
            return item
          })
          let classData = this.classtopList.map(item => {
            item.val = res.data.classExamMainInfo[item.dataIndex]
            return item
          })
          this.classtopList = classData
          this.topList = lastData
        })
      },
      //定位至指定dom
      locationDom() {
        let { location } = this.$route.query
        if (location) {
          var locationBox = document.querySelector('.' + location)
          if (locationBox) {
            window.scrollTo({
              top: locationBox.offsetTop - 80,
              behavior: 'smooth'
            })
          }
        }
      }
    }
  }
</script>
<style lang="less">
  body {
    font-family: 'PingFang SC';
  }
  ::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }
  /* 滚动槽 */
  ::-webkit-scrollbar-track {
    border-radius: 7px;
    background: transparent;
  }
  /* 滚动条滑块 */
  ::-webkit-scrollbar-thumb {
    border-radius: 7px;
    background: rgba(203, 214, 255, 0.6);
    // visibility: hidden;
  }
  ::-webkit-scrollbar-thumb:window-inactive {
    background: rgba(203, 214, 255, 0.6);
  }
  ::-webkit-scrollbar-thumb:hover {
    background-color: rgba(203, 214, 255, 1);
  }
  .title {
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    align-items: center;
    // height: 50px;
    margin-bottom: 20px;
    .right_div {
      .btn {
        margin-left: 20px;
      }
    }
  }
  .sort_son_title {
    font-weight: 500;
    color: #3d3d3d;
    font-size: 18px;
    margin-right: 20px;
  }
  .shodow {
    position: absolute !important;
    background: transparent !important;
  }
  .bgc {
    background-color: #fff;
    box-shadow: 0px 4px 16px 0px rgba(60, 100, 239, 0.0882);
    border-radius: 8px;
    padding: 20px 24px;
  }
</style>
<style lang="less" scoped>
  @font-face {
    font-family: 'PingFang SC';
    src: url('../../../assets/fonts/PingFangSC.ttf');
  }
  @font-face {
    font-family: 'DIN-Bold'; // 自己取的名字，项目中可运用
    src: url('../../../assets/fonts/DIN-Bold.otf');
    font-weight: normal;
    font-style: normal;
  }
  @font-face {
    font-family: 'DINAlternate-Bold'; //  页用字体
    src: url('../../../assets/fonts/DINAlternateBold.ttf');
    font-weight: normal;
    font-style: normal;
  }
  @font-face {
    font-family: 'huxiaobo'; // homePage 页用字体 huxiaobo 胡晓波男神字体
    src: url('../../../assets/fonts/huxiaobo.otf');
    font-weight: normal;
    font-style: normal;
  }

  .flex_row_end {
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
  .flex_row_bt {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .flex_row_st {
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }
  .ml-16 {
    margin-left: @padding-md;
  }
  .mt-32 {
    margin-top: 32px;
  }
  .mt12 {
    margin-top: @padding-sm;
  }
  /deep/.ant-select-selection {
    border: @border-width-base solid #ccd2d8;
  }

  .radius8 {
    border-radius: 8px;
  }
  .sort_fa {
    background-color: #fafafa;
    .header_div {
      width: 100%;
      background-color: #fff;
      box-shadow: 0px 4px 10px 0px rgba(60, 100, 239, 0.0392);
      // position: fixed;
      // top: 0;
      // z-index: 99;
      .content_head {
        width: 83%;
        height: 56px;
        min-width: 1200px;
        max-width: 1640px;
        margin: 0 auto;
      }
      .exam_name {
        font-size: @font-size-lg;
        font-weight: 600;
        color: @text-color-secondary;
        flex: 1;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
    .sort {
      width: 83.3%;
      min-width: 1200px;
      max-width: 1640px;
      margin: 0 auto;
      background: url(./img/page_bg.png) no-repeat top;
      background-size: 100% 605px;
      padding: 20px 0;
      min-height: calc(100vh - 60px);
      display: flex;
      flex-direction: column;
      .content_top {
        padding-top: 10px;
        .public_top {
          .top_item {
            height: 56px;
            line-height: 56px;
            font-size: @font-size-base;
            color: @text-color;
            padding: 0 0 0 20px;
            background-repeat: no-repeat;
            background-position: right;
            background-size: 157px 37px;

            span {
              color: #1d2129;
              font-family: DINAlternate-Bold-Regular, DINAlternate-Bold;
              font-size: 24px;
              font-weight: 700;
              padding-left: 46px;
            }
          }
          .top_item0 {
            background-image: url(./img/jm.png);
          }
          .top_item1 {
            background-image: url(./img/nd.png);
          }
          .top_item2 {
            background-image: url(./img/qf.png);
          }
        }
        .grade_div {
          .grade_view {
            height: 112px;
            color: @text-color-secondary;
            font-size: @font-size-base;
            background-repeat: no-repeat;
            background-position: bottom;
            background-size: 100% 70px;
            padding: 0 20px;

            .font-bold {
              color: #1d2129;
              font-family: DINAlternate-Bold-Regular, DINAlternate-Bold;
              font-size: 24px;
              font-weight: 700;
            }
            p {
              color: #999;
            }
          }

          &:first-child,
          &:nth-child(5) {
            .grade_view {
              background-image: url(./img/gradebg1.png);
            }
          }
          &:nth-child(2),
          &:nth-child(6) {
            .grade_view {
              background-image: url(./img/gradebg2.png);
            }
          }
          &:nth-child(3) {
            .grade_view {
              background-image: url(./img/gradebg3.png);
            }
          }
          &:nth-child(4) {
            .grade_view {
              background-image: url(./img/gradebg4.png);
            }
          }
        }
        .grade_title {
          // width: 50px;
          height: 112px;
          font-size: @font-size-lg;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          font-family: huxiaobo;
          font-weight: 400;
        }
      }
      .sort_div {
        padding-top: 88px;
        margin-top: -56px;
      }
      .sort_son {
        position: relative;
      }
    }
    .not_data_box {
      background-color: #fff;
      box-shadow: 0px 4px 16px 0px rgba(60, 100, 239, 0.0882);
      border-radius: 8px;
      margin-top: 32px;
    }
  }
  .right_ul {
    z-index: 9;
    position: fixed;
    right: 0px;
    top: 127px;
    /deep/.ant-anchor-wrapper {
      min-width: 88px;
      padding-left: 0;
      box-sizing: border-box;
      margin: 0;
      max-height: 80vh !important;
      background: #ffffff;
      border-radius: 8px 0px 0px 8px;
      box-shadow: 0px 4px 10px 5px rgba(60, 100, 239, 0.1);

      .ant-anchor {
        padding-left: 0;
      }
      .ant-anchor-link {
        padding: 0;
        text-align: center;
        height: 24px;
        line-height: 24px;
        margin: @padding-sm 0;
        .ant-anchor-link-title {
          font-size: @font-size-base;
          color: @text-color;
          line-height: @padding-lg;
          padding: 0 10px;
        }
        // .img {
        //   cursor: pointer;
        //   width: 42px;
        //   height: 42px;
        //   position: absolute;
        //   top: 0;
        // }
      }
      .ant-anchor-link-active {
        .ant-anchor-link-title {
          border-right: 2px solid #a78bfa;
          background: rgba(60, 100, 239, 0.1);
          color: @primaryColor;
          font-size: @font-size-base;
          font-weight: 500;
        }
      }
    }
  }
  .right_ul.fixcenter {
    top: calc(50% + 23px);
    transform: translateY(-50%);
  }
  /deep/.ant-anchor-ink {
    display: none;
  }
</style>
